var _excluded = ["className", "node", "onPlay", "showAsScreenshot"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import { EmbedNode } from '@prezly/story-content-format';
import classNames from 'classnames';
import { Iframe } from "./Iframe.mjs";
import { LinkEmbed } from "./LinkEmbed.mjs";
import { ScreenshotEmbed } from "./ScreenshotEmbed.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export function Embed(_ref) {
  var {
      className,
      node,
      onPlay,
      showAsScreenshot
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  var {
    oembed,
    url,
    layout
  } = node;
  var commonProps = _objectSpread({
    id: "embed-".concat(node.uuid),
    className: classNames('prezly-slate-embed', {
      'prezly-slate-embed--contained': layout === EmbedNode.Layout.CONTAINED,
      'prezly-slate-embed--expanded': layout === EmbedNode.Layout.EXPANDED,
      'prezly-slate-embed--full-width': layout === EmbedNode.Layout.FULL_WIDTH
    }, className),
    title: oembed.title || url
  }, props);
  if (oembed.type === 'link') {
    return /*#__PURE__*/_jsx(LinkEmbed, _objectSpread(_objectSpread({}, commonProps), {}, {
      node: node
    }));
  }
  return /*#__PURE__*/_jsx("div", _objectSpread(_objectSpread({}, commonProps), {}, {
    children: showAsScreenshot ? /*#__PURE__*/_jsx(ScreenshotEmbed, {
      className: "prezly-slate-embed__screenshot",
      node: node
    }) : /*#__PURE__*/_jsx(Iframe, {
      html: node.oembed.html || '',
      onPlay: onPlay
    })
  }));
}